<template>
  <div class="dictionary-inside">
    <el-row class="textarea-wrap">
      <el-col :span=24>
        <el-input :rows="2" autosize type="textarea" placeholder="请输入内容" v-model="textarea"
                  @input="changeInput()" />
      </el-col>
      <el-col :span="24" class="textarea-button">
        <el-button type="primary" size="small" @click="handleTrans">翻译</el-button>
      </el-col>
    </el-row>
    <template>
      <div class="translate-content" v-for="(item,index) in getTranslateDictionaryList"
           :key="`${index}-$(item.sentId)`">
        <div class="source-targeet">
          <span class="source">{{item.sourceWord}}</span>
          <span class="targeet">{{item.targetWord}}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "Dictionary",
  data () {
    return {
      value: '选项1',
      textarea: '',
    };
  },
  computed: {
    ...mapGetters('editor', [
      'getthird',               // 获取词典清空状态
      'getUrlInfo',             // 路由信息
      'getFileInfo',            // 文件信息
      'getFileTaskInfo',        // 文件任务信息
    ]),
    //不使用用辅助函数的获取数据
    getthirdinfo () {
      return this.$store.getters["editor/getthird"]
    },
    getTranslateDictionaryList () {
      if (this.getthirdinfo) {
        return this.$store.getters['editor/getTranslateDictionaryListInfo'] || []
      } else {
        return [];
      }
    },
  },

  methods: {
    changeInput () {
      this.textarea = this.textarea.replace(/^\s*/g, '');
    },
    handleTrans () {
      let params = {};
      let fileId = null;
      let sourceLang = 'zh';
      let targetLang = 'en';
      const { type } = this.getUrlInfo
      if (type === 'project') {
        const { id, sourceLang: source, targetLang: target } = this.getFileInfo
        fileId = id
        sourceLang = source;
        targetLang = target;
      } else if (type === 'task' || type === 'school') {
        const { fileId: id, sourceLang: source, targetLang: target } = this.getFileTaskInfo
        fileId = id;
        sourceLang = source;
        targetLang = target;
      }
      Reflect.set(params, 'sourceWord', this.textarea);
      Reflect.set(params, 'fileId', fileId);
      Reflect.set(params, 'sourceLang', sourceLang);
      Reflect.set(params, 'targetLang', targetLang);
      // showTarget  是否根据译文查词 0否 1是，默认0
      Reflect.set(params, 'showTarget', 1);
      this.$store.dispatch("editor/setthird", true);
      this.$store.dispatch('editor/translateDictionary', params)
    }
  },

}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>